import EmblaCarousel from 'embla';
import Autoscroll from 'embla-autoscroll';

class MediaMarquee extends HTMLElement {
  constructor() {
    super();

    this.container = this;
  }

  connectedCallback() {
    this.initialize();
  }

  initialize() {
    this.embla = EmblaCarousel(this.container, {
      loop: true,
      dragFree: true
    }, [
      Autoscroll({
        startDelay: 0,
        delay: 6000,
        stopOnInteraction: false,
        stopOnMouseEnter: false,
        stopOnFocusIn: false,
        speed: 0.5
      })
    ]);
  }
}

if (!customElements.get('media-marquee')) {
  customElements.define('media-marquee', MediaMarquee);
}